module.exports = __webpack_public_path__ + "img/b75472f972a7a94f289e5c3ad7496fb4.png";